class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' },
    );
    this.observer.observe(this);
  }

  async loadRecommendations(productId) {
    const intent = this.dataset.intent;
    const loaded = await this.fetchRecommendations(productId, intent);
    if (loaded) return;

    // Un produit sans produits complementaires renseignes ne renverrait rien :
    // on retombe alors sur les recommandations automatiques.
    const fallbackIntent = this.dataset.fallbackIntent;
    if (!fallbackIntent || fallbackIntent === intent) return;

    await this.fetchRecommendations(productId, fallbackIntent);
  }

  buildUrl(productId, intent) {
    const url = new URL(this.dataset.url, window.location.origin);
    if (intent) url.searchParams.set('intent', intent);
    url.searchParams.set('product_id', productId);
    url.searchParams.set('section_id', this.dataset.sectionId);

    return url.toString();
  }

  async fetchRecommendations(productId, intent) {
    try {
      const response = await fetch(this.buildUrl(productId, intent));
      const text = await response.text();

      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('product-recommendations');

      // La grille n'est rendue que si la reponse contient au moins un produit.
      if (!recommendations?.querySelector('.product-recommendations__grid')) return false;

      this.innerHTML = recommendations.innerHTML;
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);
